import { useState } from "react";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import IndicadorObjetivo from "./IndicadorObjetivo.jsx";
import IndicadorResultado from "./IndicadorResultado.jsx";

const Indicador = (props) => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="container-fluid">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="success">
            <strong>INDICADORES DEL PROYECTO</strong>
          </Alert>
        </Stack>
      </div>

      <div className="row">
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
          >
            <Tab value="1" label="Objetivos Especificos" />
            <Tab value="2" label="Objetivos de Resultados" />
          </Tabs>
        </Box>
      </div>

      <div className="row">
        {value === "1" ? (
          <IndicadorObjetivo
            idUsuario={props.idUsuario}
            idProyecto={props.idProyecto}
            mostrarMsg={props.mostrarMsg}
          />
        ) : (
          <IndicadorResultado
            idUsuario={props.idUsuario}
            idProyecto={props.idProyecto}
            mostrarMsg={props.mostrarMsg}
          />
        )}
      </div>
    </div>
  );
};

export default Indicador;
